/**
 * Tier display utilities for public provider pages
 */

export type Tier = 'free' | 'pro' | 'enterprise';

export type ClaimStatus = 'unclaimed' | 'pending' | 'claimed';

export type TierDisplayLabel = 'Pro' | 'Enterprise' | 'Unclaimed';

/**
 * Get human-readable display label for a tier
 */
export function getTierDisplayLabel(tier: Tier): TierDisplayLabel | null {
  switch (tier) {
    case 'pro':
      return 'Pro';
    case 'enterprise':
      return 'Enterprise';
    default:
      return null;
  }
}

/**
 * Get badge styling classes for a tier
 */
export function getTierBadgeClasses(tier: Tier): string {
  switch (tier) {
    case 'free':
      return 'bg-blue-50 text-blue-700 border-blue-200';
    case 'pro':
    case 'enterprise':
      return 'bg-primary/10 text-primary border-primary/20';
    default:
      return 'bg-blue-50 text-blue-700 border-blue-200';
  }
}

/**
 * Check if tier is verified (claimed and paid)
 */
export function isTierVerified(tier: Tier): boolean {
  return tier === 'pro' || tier === 'enterprise';
}

/**
 * Get display label for unclaimed status
 */
export function getUnclaimedBadgeLabel(): TierDisplayLabel {
  return 'Unclaimed';
}

/**
 * Get badge styling classes for unclaimed status
 */
export function getUnclaimedBadgeClasses(): string {
  return 'bg-slate-100 text-slate-500 border-slate-200';
}
